import { render, staticRenderFns } from "./SSRecords.vue?vue&type=template&id=ddd5f656&"
import script from "./SSRecords.vue?vue&type=script&lang=js&"
export * from "./SSRecords.vue?vue&type=script&lang=js&"
import style0 from "./SSRecords.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports